import { message } from 'antd';
import React from 'react';
import EditableSelect from 'client/component-library/EditableSelect/EditableSelect';
import useSetTeamType from '../../hooks/useSetTeamType';
import { useGetTeamTypes } from '../../services/hooks/useGetTeamTypesQuery';

type Props = {
  teamType: string;
  teamId: number;
  refetchTeam: () => void;
  disabled?: boolean;
};

const CopilotTeam = ({ teamType, teamId, refetchTeam, disabled }: Props) => {
  const effectiveTeamType = teamType === '' ? 'REGULAR' : teamType;
  const { setRegularTeam, setTeamTypeViaString, isLoading } = useSetTeamType({
    teamId,
  });
  const { data } = useGetTeamTypes(
    disabled ? { enabled: false } : { enabled: true }
  );

  const teamTypes = data?.team_types || [];
  const teamTypeOptions = teamTypes.map((type) => ({
    label: type.charAt(0) + type.slice(1).toLowerCase(),
    value: type,
  }));
  teamTypeOptions.push({ label: 'Regular', value: 'REGULAR' });
  const onSave = (updatedTeamType: string) => {
    const request =
      updatedTeamType !== 'REGULAR'
        ? setTeamTypeViaString(updatedTeamType)
        : setRegularTeam();
    request
      .then(() => {
        message.success(`Success! The team's type has been updated`);
        refetchTeam();
      })
      .catch(() => {
        message.success(
          `Error! Failed to update the team's type. Please try again later`
        );
      });
  };
  const renderFunction = (text: string) => {
    return <span>{text.charAt(0) + text.slice(1).toLowerCase()}</span>;
  };

  return (
    <EditableSelect
      defaultValue={effectiveTeamType}
      options={teamTypeOptions}
      render={renderFunction}
      onSave={onSave}
      disabled={disabled || isLoading}
    />
  );
};

export default CopilotTeam;
